import { supabase } from '../supabase';

const EVENT_SELECT = `
  *,
  organizer:profiles!events_organizer_id_fkey(*),
  event_participants(user_id, profiles(*))
`;

function mapEvent(event) {
  return {
    ...event,
    _id: event.id,
    organizer: event.organizer,
    participants: event.event_participants?.map(participant => ({
      ...participant.profiles,
      id: participant.user_id,
      _id: participant.user_id
    })) || [],
    startTime: event.start_time,
    endTime: event.end_time,
    sportType: event.sport_type,
    maxParticipants: event.max_participants,
    isPaid: event.is_paid
  };
}

function ensureSupabase() {
  if (!supabase) throw new Error('Supabase n’est pas configuré');
}

export async function listEvents({ sportType, date, location, organizer } = {}) {
  ensureSupabase();
  let query = supabase.from('events').select(EVENT_SELECT).order('date');
  if (sportType) query = query.eq('sport_type', sportType);
  if (date) query = query.eq('date', date);
  if (location) query = query.ilike('location', `%${location}%`);
  if (organizer) query = query.eq('organizer_id', organizer);
  const { data, error } = await query;
  if (error) throw error;
  return (data || []).map(mapEvent);
}

export async function getEvent(id) {
  ensureSupabase();
  const { data, error } = await supabase.from('events').select(EVENT_SELECT).eq('id', id).maybeSingle();
  if (error) throw error;
  return data ? mapEvent(data) : null;
}

export async function createEvent(event, userId) {
  ensureSupabase();
  const payload = {
    date: event.date,
    start_time: event.startTime,
    end_time: event.endTime || null,
    location: event.location,
    latitude: event.latitude ?? null,
    longitude: event.longitude ?? null,
    sport_type: event.sportType,
    organizer_id: userId,
    description: event.description || '',
    max_participants: event.maxParticipants || 0,
    level: event.level || 'Tous niveaux',
    is_paid: Boolean(event.isPaid)
  };
  const { data, error } = await supabase.from('events').insert(payload).select(EVENT_SELECT).single();
  if (error) throw error;
  return mapEvent(data);
}

export async function updateEvent(id, event) {
  ensureSupabase();
  const payload = {
    date: event.date,
    start_time: event.startTime,
    end_time: event.endTime || null,
    location: event.location,
    latitude: event.latitude ?? null,
    longitude: event.longitude ?? null,
    sport_type: event.sportType,
    description: event.description || '',
    max_participants: event.maxParticipants || 0,
    level: event.level || 'Tous niveaux',
    is_paid: Boolean(event.isPaid)
  };
  const { data, error } = await supabase.from('events').update(payload).eq('id', id).select(EVENT_SELECT).single();
  if (error) throw error;
  return mapEvent(data);
}

export async function deleteEvent(id) {
  ensureSupabase();
  const { error } = await supabase.from('events').delete().eq('id', id);
  if (error) throw error;
}

export async function joinEvent(eventId, userId) {
  ensureSupabase();
  const { error } = await supabase.from('event_participants').insert({ event_id: eventId, user_id: userId });
  if (error) throw error;
}

export async function leaveEvent(eventId, userId) {
  ensureSupabase();
  const { error } = await supabase.from('event_participants').delete().eq('event_id', eventId).eq('user_id', userId);
  if (error) throw error;
}

export async function reportEvent(eventId, userId, reason) {
  ensureSupabase();
  const { error } = await supabase.from('reports').insert({ event_id: eventId, reported_by: userId, reason });
  if (error) throw error;
}